import { enviroment } from "../../enviroment";

import { useAuthHttpClient } from "./useAuthHttpClient";
import { mapDtoToMunicipalities } from "../dtos/mappers/mapDtoToMunicipalities";
import { Municipality } from "../../core/entities/municipality";
import { throwIfNotSuccess } from "./throwIfNotSuccess";

const API_URL = `${enviroment.apiUrl}/api/v1/municipality`;

export function useMunicipalityService(): MunicipalityService {
    const { authFetch } = useAuthHttpClient();

    async function getAll(): Promise<Municipality[]> {
        const url = `${API_URL}`;
        const response = await authFetch(url);
        throwIfNotSuccess(response);
        const result = await response.json();
        return result.map(mapDtoToMunicipalities);
    }

    return {
        getAll
    } as MunicipalityService;
}

export interface MunicipalityService {
    getAll(): Promise<Municipality[]>;
}
